import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromReducer from '../reducers/business.reducer';

const getState = createFeatureSelector<fromReducer.BusinessState>(
    fromReducer.featureKey
);

const getPageState = createSelector(getState, (state) => state);

export const getIsLoading = createSelector(getPageState, fromReducer.isLoading);
export const getSucceeded = createSelector(getPageState, fromReducer.succeeded);
export const getHasError = createSelector(getPageState, fromReducer.hasError);
export const getErrorMessage = createSelector(getPageState, fromReducer.errorMessage);
export const getBusinessData = createSelector(getPageState, fromReducer.businessData);

export const getSucceededTypes = createSelector(getPageState, fromReducer.succeededTypes);
export const getEventHistoryTypesData = createSelector(getPageState, fromReducer.eventTypesData);
